module.exports = __webpack_public_path__ + "img/Group 172.380644d3.png";